import React, { useEffect } from "react";
import { Pagination } from "antd";
import styles from "./PaginationPage.module.css";
import "./AntdPaginationPage.css";

export const PaginationPage = (props) => {
  const { currentPage, onChange, total, pageSize, onPageSizeChange } = props;

  useEffect(() => {
    if (total === 0) {
      const singlePage = document.getElementsByClassName("ant-pagination-item-disabled")[0];
      if (singlePage) {
        singlePage.tabIndex = "-1";
        singlePage.addEventListener("click", (e) => {
          e.stopPropagation();
          return false;
        });
      }
    }
    if (total <= pageSize) {
      const singlePage = document.getElementsByClassName("ant-pagination-item-1")[0];
      if (singlePage) {
        singlePage.tabIndex = "-1";
      }
    }
  }, [total, pageSize]);

  return (
    <Pagination
      total={total}
      showTotal={(totalNum, range) => `${range[0]}-${range[1]} of ${totalNum} items`}
      pageSize={pageSize}
      className={styles.PaginationPage}
      showSizeChanger
      showLessItems
      pageSizeOptions={["3", "5", "10"]}
      onShowSizeChange={onPageSizeChange}
      defaultPageSize={5}
      onChange={onChange}
      current={currentPage}
    />
  );
};

export default PaginationPage;
